import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Spinner from "../components/Tools/spinner";

const XmlFeatureRoute = () => {
  const xmlGeneratorEnabled = useSelector(
    (state) => state.appConfig?.xmlGeneratorEnabled
  );
  const xmlGeneratorConfigLoaded = useSelector(
    (state) => state.appConfig?.xmlGeneratorConfigLoaded
  );

  if (!xmlGeneratorConfigLoaded) {
    return <Spinner />;
  }

  if (!xmlGeneratorEnabled) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default XmlFeatureRoute;
